import React, { useState, useEffect } from 'react';
// Internal module imports
import TabsComponent from '../../../../components/Tabs/Tabs';
import { RootAfrrService } from '../../../../services/RootAfrrService';
import { useLoader, useQueryParamWithDefault } from '../../../../hooks';
import { toast } from 'react-toastify';
import EICSignalIndex from './EicSignalIndex';
import { NumberParam } from 'use-query-params';
import EicDataLogs from './EicDataLogs';
import Dashboard from './Dashboard';
import CommandLog from './CommandLogs';
import { Activations } from './Activations';

const AfrrDashboard = ({ cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('tab', NumberParam, 0, cId);
    const [startLoader, stopLoader] = useLoader();
    const [eicCodeOptions, setEicCodeOption] = useState([]);

    useEffect(() => {
        getEicCodes();
    }, []);

    const getEicCodes = () => {
        RootAfrrService.GetEicCodes(startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = ({ data }) => {
        const temp = data.data
            ?.filter((item) => item.AFRR?.redisConfig)
            .map((item) => ({
                label: item.name,
                value: item.EICCode,
            }));
        setEicCodeOption(temp);
    };

    const handleError = (err) => {
        console.log(err);
        if (err && err.response) toast.error(err.response.data.message);
    };

    let tabs = [
        {
            name: 'Signal Logs',
            component: (
                <>
                    <EICSignalIndex eicCodeOptions={eicCodeOptions} cId={cId} />
                </>
            ),
            tabId: 1,
        },
        {
            name: 'Data Logs',
            component: (
                <>
                    <EicDataLogs eicCodeOptions={eicCodeOptions} cId={cId} />
                </>
            ),
            tabId: 2,
        },
        {
            name: 'Redis Viewer',
            component: (
                <>
                    <Dashboard eicCodeOptions={eicCodeOptions} cId={cId} />
                </>
            ),
            tabId: 3,
        },
        {
            name: 'Command Logs',
            component: (
                <>
                    <CommandLog eicCodeOptions={eicCodeOptions} cId={cId} />
                </>
            ),
            tabId: 4,
        },
        {
            name: 'Activations',
            component: (
                <>
                    <Activations eicCodeOptions={eicCodeOptions} cId={cId} />
                </>
            ),
            tabId: 5,
        },
    ];

    return (
        <div className=" ventilation">
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default AfrrDashboard;
